import React, { useEffect, useRef, useState } from "react";
import LayoutHOC from "../LayoutHOC";
import SideBar from "../Dashboard/SideBar";
import HeaderDashboard from "../HeaderDashboard";
const AiChatBot = () => {
  const [tables, setTables] = useState([]);
  const [loadingTables, setLoadingTables] = useState(true);
  const [messages, setMessages] = useState([]);
  const [messageInput, setMessageInput] = useState("");
  const [messageLoader, setMessageLoader] = useState(false);
  const [status, setStatus] = useState("Connected");
  const lastMessageRef = useRef(null);

  useEffect(() => {
    if (lastMessageRef.current) {
      lastMessageRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [messages]);
  useEffect(() => {
    // loadTables();
    checkStatus();
  }, []);

  const checkStatus = async () => {
    try {
      const response = await fetch("http://4.255.211.63:7888/ocr/health");
      const data = await response.json();
      if (data.status === "healthy" && data.database_connected) {
        setStatus("Connected");
      } else {
        setStatus("Disconnected");
      }
    } catch (error) {
      console.error("Status check failed:", error);
      setStatus("Error");
    }
  };

  const loadTables = async () => {
    try {
      const response = await fetch("http://4.255.211.63:7888/ocr/api/tables");
      const data = await response.json();
      if (!data.error) {
        setTables(data.tables);
      }
      setLoadingTables(false);
    } catch (error) {
      console.error("Failed to load tables:", error);
      setLoadingTables(false);
    }
  };

  const sendMessage = async () => {
    const message = messageInput.trim();
    if (!message) return;

    setMessages([...messages, { sender: "user", content: message }]);
    setMessageInput("");
    setMessageLoader(true);

    try {
      const response = await fetch("http://4.255.211.63:7888/ocr/api/chat", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ question: message }),
      });
      const data = await response.json();

      if (data.error) {
        setMessages((prev) => [...prev, { sender: "bot", content: data.error, isError: true }]);
      } else {
        setMessages((prev) => [
          ...prev,
          {
            sender: "bot",
            content: data.answer,
            data: data.data,
            sqlQuery: data.sql_query,
          },
        ]);
      }
    } catch (error) {
      console.error("Error:", error);
      setMessages((prev) => [
        ...prev,
        {
          sender: "bot",
          content: "Sorry, I encountered an error. Please try again.",
          isError: true,
        },
      ]);
    }
    setMessageLoader(false);
  };

  const sendSuggestion = (suggestion) => {
    setMessageInput(suggestion);
    sendMessage();
  };

  const showTableInfo = (tableName) => {
    const message = `Describe the structure of table ${tableName} and show me a few sample records`;
    setMessageInput(message);
    sendMessage();
  };

  return (
    <div className="flex flex-col gap-1 h-full justify-around ">
      <HeaderDashboard />
      <div class="flex gap-5 px-2 grow min-h-0 box-border">
        <div className="w-2/12">
          <SideBar />
        </div>

        <div className="flex flex-col grow min-h-0 h-full">
          <div className="h-full flex items-center justify-center bg-gradient-to-br from-indigo-500 to-purple-600 p-5">
            <div className="w-full max-w-screen-xl h-[80vh] flex flex-col overflow-hidden rounded-3xl shadow-2xl border border-white/20 backdrop-blur-xl bg-white/95">
              <div className="flex items-center gap-4 text-white px-8 py-5 bg-gradient-to-r from-blue-400 to-cyan-400 rounded-t-3xl">
                {/* <i className="fas fa-robot text-2xl animate-pulse"></i> */}
                <i class="bi bi-robot text-2xl"></i>
                <h1 className="text-xl font-semibold">Database Chatbot</h1>
                <div className="ml-auto flex items-center gap-2 text-sm px-4 py-1 bg-white/20 rounded-full">
                  <div className="w-2 h-2 rounded-full bg-green-400 animate-ping"></div>
                  <span>{status}</span>
                </div>
              </div>

              <div className="flex flex-1 overflow-hidden">
                <div className="w-[300px] bg-slate-50 border-r border-slate-200 p-5 overflow-y-auto hidden md:block">
                  <div>
                    <h3 className="text-slate-700 mb-3 text-sm font-semibold">
                      <i class="bi bi-lightbulb-fill pr-2"></i>Sample Queries
                    </h3>
                    {[
                      "What are my pending Tasks For Today?",
                      "What are my pending deals for Today?",
                      "What are my pending leads for Today?",
                      "What are my new Customers Onboarded Today to the CRM?",
                    ].map((s, i) => (
                      <div
                        key={i}
                        className="bg-yellow-100 border border-yellow-400 rounded px-3 py-2 mb-2 text-xs text-yellow-900 cursor-pointer hover:bg-yellow-300 transition"
                        onClick={() => sendSuggestion(s)}
                      >
                        {s}
                      </div>
                    ))}
                  </div>
                </div>

                <div className="flex flex-col flex-1">
                  <div className="flex-1 overflow-y-auto p-5 flex flex-col gap-4">
                    <div className="bg-slate-100 text-slate-800 self-start p-4 rounded-xl border border-slate-200 text-sm max-w-[80%]">
                      👋 Hello! I'm your database assistant. Try asking:
                      <br />
                      <br />
                      • "Show me all users"
                      <br />
                      • "What's the total count of orders?"
                      <br />
                      • "Find the most popular products"
                      <br />• "Show me sales data from last month"
                    </div>

                    {messages.map((msg, index) => (
                      <div
                        ref={index === messages.length - 2 ? lastMessageRef : null}
                        key={index}
                        className={`text-sm p-4 rounded-xl max-w-[80%] ${
                          msg.sender === "user"
                            ? "self-end bg-gradient-to-br from-indigo-500 to-purple-500 text-white rounded-br-md"
                            : "self-start bg-slate-100 text-slate-800 border border-slate-200 rounded-bl-md"
                        }`}
                      >
                        <div>{msg.content}</div>

                        {msg.sqlQuery && (
                          <pre className="bg-gray-900 text-gray-100 p-3 rounded mt-2 text-xs overflow-x-auto">
                            <strong>SQL Query:</strong>
                            <br />
                            {msg.sqlQuery}
                          </pre>
                        )}
                        {msg.isError && (
                          <div className="bg-red-100 border border-red-200 text-red-600 p-3 rounded mt-2 text-xs">
                            There was an error processing your request.
                          </div>
                        )}
                      </div>
                    ))}
                    {messageLoader && (
                      <div className="flex items-center gap-2">
                        <div className="spinner-ai"></div>
                        <div className="thinking-dots">Thinking</div>
                      </div>
                    )}
                  </div>

                  <div className="p-5 bg-slate-50 border-t border-slate-200 flex items-center gap-4">
                    <div className="flex-1 relative">
                      <input
                        type="text"
                        value={messageInput}
                        placeholder="Ask me anything about your database..."
                        className="w-full p-4 border-2 border-slate-200 rounded-full text-sm outline-none transition focus:border-indigo-500 focus:ring-4 focus:ring-indigo-100 bg-white"
                        onChange={(e) => setMessageInput(e.target.value)}
                        onKeyPress={(e) => e.key === "Enter" && sendMessage()}
                      />
                    </div>
                    <button
                      className="bg-gradient-to-br from-indigo-500 to-purple-500 text-white w-12 h-12 rounded-full flex items-center justify-center text-lg hover:scale-105 hover:shadow-lg disabled:opacity-60"
                      onClick={sendMessage}
                      disabled={!messageInput.trim()}
                    >
                      <i class="bi bi-send-fill"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AiChatBot;
